export default "__VITE_ASSET__2sQiCXVP__"